// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function isVideoURL(url) {
  var parts = url.split(/\?/);
  var part0 = Belt_Option.getWithDefault(Belt_Option.getWithDefault(Belt_Array.get(parts, 0), undefined), "");
  return Belt_Option.isSome(Caml_option.null_to_opt(part0.toLowerCase().match(/(.mp4|.m3u8|.mov)$/)));
}

function sort(url) {
  var url$1 = new URL(url);
  url$1.searchParams.sort();
  return url$1.href;
}

function setQueryParam(url, param, value) {
  var url$1 = new URL(url);
  url$1.searchParams.set(param, value);
  url$1.searchParams.sort();
  return url$1.href;
}

function getQueryParam(url, param) {
  var url$1 = new URL(url);
  return Caml_option.nullable_to_opt(url$1.searchParams.get(param));
}

function removeQueryParam(url, param) {
  var url$1 = new URL(url);
  url$1.searchParams.delete(param);
  url$1.searchParams.sort();
  return url$1.href;
}

function makeUrl(url, params) {
  var url$1;
  if (url[0] === "/") {
    var base = window.location.protocol + window.location.hostname + ":" + window.location.port;
    url$1 = new URL(url, base);
  } else {
    url$1 = new URL(url);
  }
  Belt_Array.forEach(Js_dict.entries(params), (function (param) {
          url$1.searchParams.set(param[0], param[1]);
        }));
  url$1.searchParams.sort();
  return url$1.href;
}

function getCurrentUrl(param) {
  return window.location.href;
}

function getOrigin(url) {
  return new URL(url).origin;
}

function getCurrentQueryParams(param) {
  try {
    return Js_dict.fromArray(Array.from(new URL(window.location.href).searchParams.entries()));
  }
  catch (exn){
    return {};
  }
}

function toString(params) {
  var searchParams = new URLSearchParams(params);
  var s = searchParams.toString();
  if (s === "") {
    return "";
  } else {
    return "?" + s;
  }
}

export {
  isVideoURL ,
  sort ,
  setQueryParam ,
  getQueryParam ,
  removeQueryParam ,
  makeUrl ,
  getCurrentUrl ,
  getOrigin ,
  getCurrentQueryParams ,
  toString ,
}
/* No side effect */
